var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSequoia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.52 24.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sequoia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        path{\n        fill: white;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06,18.9q0-9.45,0-18.9H0V22.37c.93-.91,1.86-1.81,2.77-2.75A1.15,1.15,0,0,0,3.06,18.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95,21.7c-.95.92-1.87,1.88-2.8,2.82H24.52V21.45H5.62A1,1,0,0,0,4.95,21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63,13.8a1.71,1.71,0,0,0,.57-1.47c0-4.11,0-8.22,0-12.33H6.13V16.27C7.06,15.34,7.8,14.52,8.63,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.23,15.43c-1,.89-1.94,1.83-2.91,2.75l.14.2H24.52V15.32H12C11.76,15.33,11.39,15.28,11.23,15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.39,0V6.13h6.13V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7.43a1.4,1.4,0,0,0,.36-.85c0-2.19,0-4.38,0-6.58H12.26V10.15C13.28,9.13,14.14,8.3,15,7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.36,9.29c-1,.9-1.94,1.83-2.91,2.75l.15.22h9.92V9.19H17.87A.82.82,0,0,0,17.36,9.29Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequoia);
export default __webpack_public_path__ + "static/media/Sequoia.9ea8943f4e80cbfcb9ac603fc54981d1.svg";
export { ForwardRef as ReactComponent };